module.exports = __webpack_public_path__ + "static/media/agri.95269181.PNG";